import type {
	ConfirmResetPasswordInput,
	ConfirmSignUpInput,
	ConfirmSignUpOutput,
	ResetPasswordInput,
	ResetPasswordOutput,
	SignInInput,
	SignInOutput,
	SignUpInput,
	SignUpOutput,
	UpdatePasswordInput
} from 'aws-amplify/auth';
import {
	confirmResetPassword as confirmResetPasswordFn,
	confirmSignUp as confirmSignUpFn,
	fetchAuthSession as fetchAuthSessionFn,
	resetPassword as resetPasswordFn,
	signIn as signInFn,
	signOut as signOutFn,
	signUp as signUpFn,
	updatePassword as updatePasswordFn
} from 'aws-amplify/auth';
import { Observable, defer } from 'rxjs';

import { useBackendHttpService } from '~/services/http';

import { AuthToken } from './domain';

/* AWS Authentication methods */
export function signIn(payload: SignInInput): Observable<SignInOutput> {
	return defer(() => signInFn(payload));
}

export function signUp(payload: SignUpInput): Observable<SignUpOutput> {
	return defer(() => signUpFn(payload));
}

export function confirmSignUp(payload: ConfirmSignUpInput): Observable<ConfirmSignUpOutput> {
	return defer(() => confirmSignUpFn(payload));
}

export function signOut(): Observable<void> {
	return defer(() => signOutFn());
}

export function resetPassword(payload: ResetPasswordInput): Observable<ResetPasswordOutput> {
	return defer(() => resetPasswordFn(payload));
}

export function confirmResetPassword(payload: ConfirmResetPasswordInput): Observable<void> {
	return defer(() => confirmResetPasswordFn(payload));
}

export function updatePassword(payload: UpdatePasswordInput): Observable<void> {
	return defer(() => updatePasswordFn(payload));
}

export function fetchAuthSession() {
	return defer(() => fetchAuthSessionFn());
}

/* Silae Access Code */
const ACCESS_TOKEN_API = '/access-code/v1';

export function requestJWTToken(impersonationSilaeCode: string): Observable<AuthToken> {
	const { http } = useBackendHttpService();
	return http.post(ACCESS_TOKEN_API, { impersonationSilaeCode });
}
